import { GET_ANIMALS_PROTECTORA } from '../../AnimalList/actions/actionsAnimalList'
import { CHANGE_ELEMENTS_PER_ROW_PROTECTORA } from '../../AnimalList/actions/actionsAnimalList'
import { IMAGE_LOADED_PROTECTORA } from '../../AnimalList/actions/actionsAnimalList'
import { IMAGE_ERROR_PROTECTORA } from '../../AnimalList/actions/actionsAnimalList'
import { CHANGE_IS_READY_PROTECTORA } from '../../AnimalList/actions/actionsAnimalList'
import { RESET_READY_PROTECTORA } from '../../AnimalList/actions/actionsAnimalList'
import { CHANGE_IS_REMOVING_PROTECTORA } from '../../AnimalList/actions/actionsAnimalList'
import {reducerAnimalList} from "../../AnimalList/reducers/reducerAnimalList";

const initialState = {
	list: [],
	totalRecord: 0,
	pag: 0,
	elementsPerRow: 0,
    elementsPerPage: 0,
	imagesOnPage: 0,
	imagesLoaded: 0,
	imagesError: 0,
    isReady: false,
    isRemoving: false,
    imagesurl:[]
};

export function reducerAnimalControlProtectora(state = initialState, action) {

	switch (action.type) {
		case GET_ANIMALS_PROTECTORA:
			return Object.assign({}, state, {
				list: action.payload.result,
                totalRecord: action.payload.totalRecord,
				pag: action.payload.pag,
                elementsPerRow: action.payload.elementsPerRow,
                elementsPerPage: action.payload.elementsPerPage,
                imagesOnPage: action.payload.imagesOnPage,
            	imagesLoaded: action.payload.imagesLoaded,
            	imagesError: action.payload.imagesError,
				isReady: action.payload.isReady,
                imagesurl: action.payload.imagesurl
			});
        case CHANGE_ELEMENTS_PER_ROW_PROTECTORA:
            return Object.assign({}, state, {
                elementsPerRow: action.payload.elementsPerRow
            });
        case IMAGE_LOADED_PROTECTORA:
            return Object.assign({}, state, {
                imagesLoaded: action.payload.imagesLoaded
            });
        case IMAGE_ERROR_PROTECTORA:
            return Object.assign({}, state, {
                imagesError: action.payload.imagesError
            });
        case CHANGE_IS_READY_PROTECTORA:
            return Object.assign({}, state, {
                isReady: action.payload.isReady
            });
        case CHANGE_IS_REMOVING_PROTECTORA:
            return Object.assign({}, state, {
                isRemoving: action.payload.isRemoving
            });
        case RESET_READY_PROTECTORA:
            return Object.assign({}, state, {
                isReady: action.payload.isReady,
                imagesLoaded: action.payload.imagesLoaded,
                imagesError: action.payload.imagesError
            });
		default:
			return state
	}
}